export const VisitCounselingFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}
function header(form_data) {
  return [
    {
      w: '100%', h: 80, text: '國立臺灣科技大學\n校外實習學生訪視輔導記錄表',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },
  ];
}

function page(blueprint, form_data) {
  return [
    { w: '18%', h: 30, text: '就讀系所' },
    { w: '32%', h: 30, text: form_data.department_id },
    { w: '18%', h: 30, text: '學號' },
    { w: '32#', h: 30, text: form_data.student_account },

    { w: '18%', h: 30, text: '學生姓名' },
    { w: '32%', h: 30, text: form_data.student_name },
    { w: '18%', h: 30, text: '單位主管姓名' },
    { w: '32#', h: 30, text: form_data.manager },

    { w: '18%', h: 50, text: '實習單位' },
    { w: '32#', h: 50, text: form_data.internship },
    { w: '18%', h: 50, text: '部門別\n（上班班別）' },
    { w: '32%', h: 50, text: form_data.work_department },

    { w: '18%', h: 50, text: '輔導日期' },
    { w: '82#', h: 50, text: date_to_str(form_data.counseling_date) },

    { w: '18%', h: 80, text: '訪視方式' },
    { w: '36#', h: 80, not_take_space: true },
    { w: '14#', h: 80, align: 'right', all_wrap: true, border_width: 0, texts: form_data.visit },
    {
      w: '22#', h: 80, align: 'left', baseline: 'top', padding: 10, border_width: 0,
      text: `TEL: ${form_data.visit_tel ? form_data.visit_tel : '____________________'}`,
    },
    { w: '18%', h: 80, text: '住宿調查' },
    { w: '28#', h: 80, texts: form_data.provide_stay },
    {
      w: '100%', h: 30, text: '學生實習概況 (依據與學生訪談狀況給分)',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    ...check_radio_table(blueprint.find(block => block.key == 'student_check').items, form_data.student_check),


    {
      w: '100%', h: 30, text: '實習廠商對於實習學生安排與規劃 (依據與實習單位主管訪談狀況給分)',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    ...check_radio_table(blueprint.find(block => block.key == 'intern_check').items, form_data.intern_check),

    {
      w: '100%', h: 30, text: '綜合評語',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { w: '100%', h: 100, padding: 10, align: 'left', baseline: 'top', text: form_data.comments },

    { w: '100%', h: 30, border_width: 0 },

    { w: '16%', h: 30, text: '實習輔導教師' },
    { w: '32%', h: 30, text: form_data.intern_teacher },
    { w: '20%', h: 30, text: '教學單位單位主管' },
    { w: '32#', h: 30, text: form_data.school_manager },
  ];
}

function check_radio_table(items, values) {
  return items.map((item, index) => {
    return [
      { w: '50%', h: 30, padding: 10, align: 'left', text: item },
      { w: '50%', h: 30, padding: 10, texts: values[index] },
    ];
  }).flat();
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}